import React from "react";
import { getStyle } from "../../styles/styles";
import AlertBox from "../shared/AlertBox";
import LoadingBox from "../shared/LoadingBox";
import { RunBNEOD, ValidateBNEOD } from "../../networking/NetworkingEOD";
import { getNextBusinessDate } from "../../networking/NetworkingHolidays";
import { GlobalSystemParametersNames } from "../../constants/GlobalSystemParametersNames";
import AppContext from "../../AppContext";
let globalFunctions = {}

var style = getStyle()
const fontSize = {
    fontSize: '20px'
    }
    
export default class BNEndOfDayProcessScreen extends React.Component {
    static contextType = AppContext;

    state = {
        currentBusinessDay: '',
        eodAlertMessage: '',
        eodLog: '',
        lastClosedDate : '',
        nextBusinessDay :'',
        loading : false,
        showAlert: false,
        showConfirm : false,
        showEODAlert: false,
        showErrorAlert: false
    }

    componentDidMount() {
        globalFunctions = this.context;
        let systemDate = localStorage.getItem(GlobalSystemParametersNames.BNSystemDate);
        this.setState({loading : true, currentBusinessDay : systemDate, 
                lastClosedDate : localStorage.getItem(GlobalSystemParametersNames.BNLastClosingDate)});

        this.GetNextBusinessDate(systemDate);
    }

    yesConfirm() {
        this.setState({showConfirm: false, loading: true});

        localStorage.setItem('StopGettingSession', true);
        this.RunEOD();
    }

    yesEODConfirm() {
        this.setState({showEODAlert: false, eodAlertMessage:'', loading: true});

        localStorage.setItem('StopGettingSession', true);
        this.RunEOD();
    }
    
    openConfirm(){
        this.setState({showConfirm: true});
    }

    closeConfirm(){
        this.setState({showConfirm: false});
    }
    
    closeEODConfirm(){
        this.setState({showEODAlert: false});
    }

    closeAlert = () => {
        this.setState({showAlert: false});
        globalFunctions.forceLogout();
    }
    
    closeErrorAlert = () => {
        this.setState({showErrorAlert: false});
    }

    //Functions
    GetNextBusinessDate(systemDate){
        if(systemDate !== undefined){
            getNextBusinessDate(systemDate,0).then(
                (json) => {
                    if(json !== undefined && json.nextDate !== undefined)
                    {
                        this.setState({nextBusinessDay : json.nextDate});
                    }
                    this.setState({loading : false});
                }
            )
        }
    }

    RunEOD(){
        RunBNEOD().then(
            (value)=> {
                if(value !== undefined) {
                    if(value.errorMessage !== undefined && value.errorMessage === ""){
                        //Do something
                        if(value.lastClosingDate !== undefined)
                        {
                            this.setState({lastClosedDate : value.lastClosingDate});
                        }    
                        if(value.systemDate !== undefined)
                        {
                            this.setState({currentBusinessDay : value.systemDate});
                            this.GetNextBusinessDate(value.systemDate);
                        }   
                        this.setState({showAlert : true});   
                    } else {
                        if(value.errorMessage !== undefined)
                        {
                            this.setState({eodLog : value.errorMessage});
                        }
                    }
                }
                this.setState({loading: false});
            }).finally(() => { 
                localStorage.setItem('StopGettingSession', false);
            });
    }

    //Handles
    handleProcessClick(){
        ValidateBNEOD(this.state.currentBusinessDay).then(
            (value) => {
                if(value != undefined && value != null && value.validateMessage != ''){
                    this.setState({showEODAlert: true, eodAlertMessage: value.validateMessage});
                }else{
                    this.openConfirm();
                }
            }
        )
    }

    render() {
        return (
            <div>
                <h3 className="uk-heading-divider" style={style.titleStyle}>End of day process</h3>
                <form className="uk-form-stacked uk-grid">
                    <div className="uk-width-1-1">
                        <div className="uk-margin">
                            <label className="uk-form-label" style={fontSize} >Last closed date {this.state.lastClosedDate}</label>
                        </div>
                    </div>
                    <div className="uk-width-1-1">
                        <div className="uk-margin">
                            <label className="uk-form-label" style={fontSize} > Current business date {this.state.currentBusinessDay}</label>
                        </div>
                    </div>
                    <div className="uk-width-1-1">
                        <div className="uk-margin">
                            <label className="uk-form-label" style={fontSize} > Next business date {this.state.nextBusinessDay}</label>
                        </div>
                    </div>     
                    <div className="uk-width-1-1">
                        <button className="uk-button uk-button-green uk-float-right" type="button" onClick={this.handleProcessClick.bind(this)}>End Of Day</button>
                    </div>               
                </form>
                <AlertBox id="bneod-yesno-confirm" type="Yes/No" open={this.state.showConfirm} title="Are you sure you want to continue?" 
                    message="This action can not be undone." yesClick={this.yesConfirm.bind(this)} noClick={this.closeConfirm.bind(this)} 
                    onClose={this.closeConfirm.bind(this)}/>
                <AlertBox id="bneod-yesno-confirm-eod" type="Ok" open={this.state.showEODAlert} title="Alert" 
                    message={this.state.eodAlertMessage} okClick={this.closeEODConfirm.bind(this)} onClose={this.closeEODConfirm.bind(this)}/>
                <LoadingBox loading={this.state.loading}/>
                <AlertBox id="bneod-global-Alert" type="Ok" open={this.state.showAlert} title="Message" 
                    message="EOD process finished successfully. You will be redirected to the login screen." okClick={this.closeAlert} 
                    onClose={this.closeAlert}/>
                <AlertBox id="bneod-error-Alert" type="Ok" open={this.state.showErrorAlert} title="Message" 
                    message="An error has ocurred. Please try again later" okClick={this.closeErrorAlert} 
                    onClose={this.closeErrorAlert}/>
            </div>
        )
    }
}